exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.form-complete-area[data-v-497a1f96] {\n  width: 100%!important;\n}\n.form-complete-area__lead[data-v-497a1f96] {\n  margin: 50px auto;\n}\n", ""]);

// exports
